/** @format */

import {ReactNode} from 'react';

import {Navigate} from 'react-router-dom';

import Alert from '@mui/material/Alert';

import {useGetTariffPeriodEndQuery} from './graphql/__generated__';
import {getDaysLeft} from './helpers/getDaysLeft';
import {parseEndDate} from './helpers/parseEndDate';

interface Props {
  children: ReactNode;
}

const TariffRedirect = ({children}: Props) => {
  const {data, error, loading} = useGetTariffPeriodEndQuery();

  const {isValid: isValidDate, parsedEndDate} = parseEndDate(
    data?.currentUser?.subscription.endDate,
  );
  const isError = (!isValidDate && !loading) || error;

  // Мы не можем показывать приватные страницы, если не понимаем, какой тариф у юзера и когда он кончается

  if (isError) {
    return <Alert severity='error'>Что-то пошло не так</Alert>;
  }

  const daysLeft = isValidDate ? getDaysLeft(parsedEndDate) : Infinity;

  // При истекшем тарифе показываем страницу тарифов

  if (daysLeft < 1) {
    return <Navigate to={{pathname: '/tariffs'}} />;
  }

  return children;
};

export {TariffRedirect};
